import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useBlogCategory } from "../useHook";

function BlogLinkedCategoryDetail() {
  const location = useLocation();
  const { blogId } = location.state || {};
  const { getBlogCategoryById } = useBlogCategory();
  const [activeTab, setActiveTab] = useState("description");
  const [blogDetails, setBlogDetails] = useState(null);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    if (blogId) {
      getBlogCategoryById(blogId, setBlogDetails);
    }
  }, [blogId]);

  if (!blogDetails) {
    return <div className="text-center py-6">Loading blog details...</div>;
  }

  return (
    <div className="bg-gray-100 min-h-screen flex flex-col p-4 overflow-hidden">
      <div className="bg-white shadow-md rounded-lg p-6 mb-6 flex-grow overflow-y-auto">
        <div className="flex flex-col gap-6">
          <div>
            <h1 className="text-3xl font-bold text-gray-800">
              Blog Title: {blogDetails.name || "Untitled Blog"}
            </h1>
            <p className="text-sm text-gray-600 mb-2">
              <strong>Status:</strong>{" "}
              <span
                className={`font-semibold ${
                  blogDetails.status ? "text-green-600" : "text-red-600"
                }`}
              >
                {blogDetails.status ? "Active" : "Inactive"}
              </span>
            </p>
            <p className="text-sm text-gray-600 mb-2">
              <strong>Category ID:</strong>{" "}
              {blogDetails.categoryId || "Uncategorized"}
            </p>
            <p className="text-sm text-gray-600 mb-2">
              <strong>Created At:</strong>{" "}
              {new Date(blogDetails.createdAt).toLocaleString()}
            </p>
            <p className="text-sm text-gray-600 mb-4">
              <strong>Updated At:</strong>{" "}
              {new Date(blogDetails.updatedAt).toLocaleString()}
            </p>
          </div>
        </div>

        <div className="w-full mt-6">
          <div className="flex border-b border-gray-300">
            <button
              className={`w-full py-2 text-sm font-medium ${
                activeTab === "description"
                  ? "border-b-2 border-blue-500 text-blue-500"
                  : "text-gray-700"
              }`}
              onClick={() => handleTabChange("description")}
            >
              Description
            </button>
          </div>
          <div className="w-full p-4">
            {activeTab === "description" && (
              <p className="text-sm text-gray-600 mb-4">
                <strong>Description:</strong>{" "}
                {blogDetails.description || "No description available"}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default BlogLinkedCategoryDetail;
